<template lang="pug">
  b-card.list-calendar(title="Calendarios")
    b-form-checkbox.checkbox-calendar(
      v-model="calendar.isActive"
      v-for="calendar in calendars"
      :key="calendar.id"
      @change="calendarSetActive (calendar.id, $event)"
    ) {{calendar.name}}
    b-button.boton(:href="googleOAuthUrl" variant="secondary" size="sm" block) Vincular cuenta
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  methods: {
    ...mapActions(['getGoogleCalendarAuthUrl', 'listCalendar', 'editCalendar', 'listEvent']),
    ...mapActions('AuthenticationStore', ['getGoogleOAuthUrl', 'linkGoogleAccount']),
    async calendarSetActive (id, isActive) {
      await this.editCalendar({ id, data: { isActive } })
      await this.listEvent()
    }
  },
  computed: {
    ...mapGetters(['googleCalendarAuthUrl', 'calendars']),
    ...mapGetters('AuthenticationStore', ['googleOAuthUrl'])
  },
  async created () {
    this.listCalendar()
    this.getGoogleOAuthUrl()
    const code = this.$route.query.code
    if (code) {
      await this.linkGoogleAccount({ data: { code } })
      await this.listCalendar()
      await this.listEvent()
    }
  }
}
</script>

<style lang="scss" scoped>
.list-calendar {
  .card-title {
    font: normal normal 600 24px/28px Open Sans;
  }
  width: 353px;
  .checkbox-calendar {
    color: #7F828F;
    margin-bottom: 0.5rem;
  }
}
.card {
  border: none;
}
</style>